export const INPUT_CODE = {
  EFFECTIVE_DATE: "effectiveDate",
  INSURED_DATE_OF_BIRTH: "insuredDateOfBirth",
  INSURED_GENDER: "insuredGender",
  LEAD_REQUEST: "leadRequest",
  FULL_NAME: "fullName",
  MOBILE_NUMBER: "mobileNumber",
};

export const RULE_CODE = {
  REQUIRED: "required",
  TH_ID_CARD: "thIdCard",
  RANGE_FROM_NOW: "rangeFromNow",
  IN: "in",
  CHARACTER_LENGTH: "characterLength",
  BMI: "BMI",
  ONE_BENEFICIARY_PERSON: "oneBeneficiaryPerson",
  OTP: "otp",
  LICENSE_PLATE: "licensePlate",
  AGE_BY_YEAR_0: "ageByYear0",
  AGE_BY_DAY_0: "ageByDay0",
  BENEFICIARY_PERSON_COUNT: "beneficiaryPersonCount",
  FULL_NAME: "fullName",
  EMAIL: "email",
  PHONE_NUMBER: "phoneNumber",
};
